import { SEO_IMAGES, type SeoImageId } from '@snakefeast/shared';

/**
 * A captioned screenshot: responsive WebP sources, fixed dimensions (no layout shift),
 * descriptive alt text, and lazy loading unless it's the first thing on the page.
 */
export function Picture({ id, priority = false, alt, caption }: { id: SeoImageId; priority?: boolean; alt?: string; caption?: string }) {
  const img = { ...SEO_IMAGES[id], ...(alt ? { alt } : {}), ...(caption ? { caption } : {}) };
  const largest = img.variants[img.variants.length - 1]!;
  return (
    <figure className="content-figure">
      <img
        src={largest.url}
        srcSet={img.variants.map((v) => `${v.url} ${v.width}w`).join(', ')}
        sizes="(max-width: 860px) calc(100vw - 32px), 820px"
        width={img.width}
        height={img.height}
        alt={img.alt}
        loading={priority ? 'eager' : 'lazy'}
        fetchPriority={priority ? 'high' : 'auto'}
        decoding="async"
      />
      <figcaption>{img.caption}</figcaption>
    </figure>
  );
}
